import React, { Component} from 'react';
import {
    Table, Button, DatePicker, Card, PageHeader, message, Input, Space
} from 'antd';
import Xhr from '../libs/Xhr';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import Utility from "../libs/Utility";
import './scss/RoomCharDetail.scss';
import moment from "moment";

export default class RoomProfferDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            currentPage: 1,
            pageSize: 10,
            selectedRowKeys: [],
            loading: false,
            startTime: "",
            endTime: "",
            total: 0,
            roomId: 0,
            uid: 0,
            name: '',
            startValue: '',
            endValue: '',
            endOpen: false,
            lang: 'zh_cn',
            tableScrollX: 1000,
        }

        this._columns = [
            {
                title: Utility.language('日期', this.state.lang),
                dataIndex: 'dateline',
                key: 'dateline',
                render: (text, record) => {
                    return text ? Utility.dateFormat(new Date(text * 1000), 'yyyy-MM-dd') : '';
                },
            },
            {
                title: Utility.language('UID', this.state.lang),
                dataIndex: 'uid',
                key: 'uid',
                ...this.getColumnSearchProps('uid'),
            },
            {
                title: Utility.language('昵称', this.state.lang),
                dataIndex: 'name',
                key: 'name',
                ...this.getColumnSearchProps('name'),
            },
            {
                title: Utility.language('魅力值', this.state.lang),
                dataIndex: 'money',
                key: 'money',
                defaultSortOrder: 'descend',
                sorter: (a, b) => a.money - b.money,
            },
            {
                title: Utility.language('Ranking', this.state.lang),
                dataIndex: 'rank',
                key: 'rank',
                defaultSortOrder: 'descend',
                sorter: (a, b) => a.rank - b.rank,
            }
        ]

        this._load();
    }

    componentDidMount() {
        this.userinfo();
    }

    userinfo = () => {
        var uinfo = localStorage.getItem('uinfo');
        var lang = localStorage.getItem('lang');
        this.setState({
            lang: lang ? lang : 'zh_cn',
        })
        uinfo = JSON.parse(uinfo);
        if (!uinfo) {
            this.props.history.push('/static/login');
        }
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({
            searchText: ''
        });
    };

    onSearch = () => {

        this.setState({
            currentPage: 1,
        }, () =>{
            this._load();
        })

    }

    onOk(value) {
        //('onOk: ', value);
    }

    handleTableChange = (pagination) => {
        // this.setState({
        //     currentPage: pagination,
        // }, () =>{
        //     this._load();
        // })
    }

    tableChange = (pagination, filters, sorter, extra) => {
        if(extra.action !== 'paginate')
            return false;
        this.setState({
                currentPage: pagination.current,
                pageSize: pagination.pageSize,
            },()=>this._load()
        );
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    start = () => {
        this.setState({ loading: true });
        setTimeout(() => {
            this.setState({
                selectedRowKeys: [],
                loading: false,
            });
        }, 500);
    };

    onStartChange = (value, dateString) => {
        this.setState({
            'startValue': value
        });
    };

    async _load() {
        let start_time = this.state.startValue;
        let end_time = this.state.endValue;
        let roomId = 0;

        try {
            roomId = this.props.location.state.rid;
        } catch (e) {
            if (!roomId)
            {
                message.error(Utility.language('缺少房间参数，请从上个页面重新进来', this.state.lang));
                return false;
            }
        }

        if (start_time)
            start_time = start_time.format('YYYY-MM-DD');
        if (end_time)
            end_time = end_time.format('YYYY-MM-DD');

        var bid = localStorage.getItem('bid');
        let page = this.state.currentPage;
        let limit = this.state.pageSize;

        let res = await Xhr.get('roomwater/getProfferDetail?bid=' + bid + '&room_id=' + roomId + '&start_time=' + start_time + '&end_time=' + end_time + '&page=' + page + '&limit=' + limit)
        if (res.success) {
            this.setState({
                data: res.data.data,
                total: res.data.total,
                roomId: res.data.room_info.room_id,
                uid: res.data.room_info.uid,
                name: res.data.room_info.name,
            });
        }else{
            message.error(res.msg)
        }
    }

    render() {
        const { startValue, endValue, endOpen, tableScrollX } = this.state;

        const paginationProps = {
            onChange : (page) => this.handleTableChange(page),
            total: this.state.total,
            showSizeChanger: true,
            defaultCurrent: this.state.currentPage,
            current: this.state.currentPage,
            defaultPageSize: 10,
            pageSizeOptions: [10],
        }

        return (
            <article className="page-room-char-detail">
                <PageHeader
                    className="site-page-header"
                    onBack={() => window.history.back()}
                    title={Utility.language('返回房间流水', this.state.lang)}
                    subTitle=""
                />
                <header className="prcd-header">
                    <Space>
                        <span>{Utility.language('房间贡献榜单', this.state.lang)}</span>
                        <Card bordered={false}>
                            <span>{Utility.language('房间id', this.state.lang)}：{this.state.roomId} {Utility.language('房主ID', this.state.lang)}：{this.state.uid} {Utility.language('房主昵称', this.state.lang)}：{this.state.name}</span>
                        </Card>
                    </Space>
                    <Space>
                        {Utility.language('日期', this.state.lang)} ：
                        <DatePicker
                            format="YYYY-MM-DD"
                            defaultValue={moment().add("-1", "days")}
                            onChange={this.onStartChange}
                            onOk={this.onOk}
                        />
                        <Button type="primary" onClick={this.onSearch}>{Utility.language('查询', this.state.lang)}</Button>
                    </Space>
                </header>
                <Table
                    className="prcd-table"
                    scroll={{ x: tableScrollX }}
                    rowKey={record => record.uid}
                    columns={this._columns}
                    dataSource={this.state.data}
                    bordered
                    pagination={paginationProps}
                    onChange={this.tableChange}
                />
            </article>
        );
    }
}